export default 'access_token';
export const DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ssxxx";
export const ARMENIAN_TIME_ZONE_HOURS = '+04:00';
export const CONTRACT_START_ISO_TIME = 'T00:00:00';
export const CONTRACT_END_ISO_TIME = 'T23:59:59';

export const DATE_FORMAT_SHORT = 'yyyy-MM-dd';
export const DATE_FORMAT_WITH_TIME = "yyyy-MM-dd' 'HH:mm:ss";
export const EKENG_DATE_FORMAT = 'dd/MM/yyyy';
export const DATE_FORMAT_DISPLAY = 'dd/MM/yyyy';
export const TIME_FORMAT = 'HH:mm:ss';

export const ARM_TIMEZONE = 'Asia/Yerevan';

export const MOBILE_BREAKPOINT = 767;

export const INTERNAL_SERVER_ERROR_KEY = 'lerror_500';

export const LANGUAGES = {
  HY: 'hy',
  EN: 'en',
  RU: 'ru',
};

export const FIELD_NAME_MAPPING = {
  [LANGUAGES.HY]: 'nameHy',
  [LANGUAGES.EN]: 'nameEn',
  [LANGUAGES.RU]: 'nameRu',
};

export const OLD_FIELD_NAME_MAPPING = {
  [LANGUAGES.HY]: 'nameHY',
  [LANGUAGES.EN]: 'nameEN',
  [LANGUAGES.RU]: 'nameRU',
};

export const COUNTRIES = {
  ARM: {
    id: 1,
    iso3: 'ARM',
    label: 'ARM',
    nameEN: 'RA',
    nameHY: 'ՀՀ',
    nameRU: 'РА',
    masysId: 1,
  },
};

export const YEREVAN_CITY_VILLAGE = {
  id: 795,
  name_HY: 'Երևան',
  name_EN: 'Yerevan',
  name_RU: 'Ереван',
  label: 'YR01',
  ra_state_id: 1,
  name_FA: 'Yerevan',
  masys_id: '1042',
  ekeng_name: 'ԵՐԵՎԱՆ',
};

export const GENDER = {
  MALE: 1,
  FEMALE: 2,
};

export const GENDER_OPTIONS = [
  { key: GENDER.MALE, label: 'personalInfo.male', value: GENDER.MALE, id: GENDER.MALE },
  { key: GENDER.FEMALE, label: 'personalInfo.female', value: GENDER.FEMALE, id: GENDER.FEMALE },
];

export const SUCCESS_SCREEN_PDF_REQUEST_LIMIT = 12;

export const MIN_USER_AGE = 18;

export const CMTPL_EXTERNAL_URL = 'https://aswa.am/self-signing/?icKey=bcac7322-874a-11e7-bb31-be2e44b06b34';
export const MAIN_PORTAL_URL = 'https://www.efes.am/';

export const TRAVEL_CONTRACT_DAYS_DEBOUNCE = 800;

export const APPLICANT_TYPES = [
  { value: 1, key: 'physical', label: 'cmtplForm.personalData.physical' },
  { value: 2, key: 'legal', label: 'cmtplForm.personalData.legal' },
];

export const DAMAGED_CAR_OPTIONS = [
  { value: 0, label: 'cmtplForm.accInfo.yes' },
  { value: 1, label: 'cmtplForm.accInfo.no' },
];

export const PROCEEDINGS = [
  { value: 'conducted_with_act', label: 'existsAndIsValid' },
  { value: 'conducted_without_act', label: 'existsAndIsInvalid' },
  { value: 'not_conducted', label: 'doesntExist' },
];

export const COMPENSATION_TYPES = [
  { value: 'repair', label: 'cmtplForm.compensation.compensationType.repair' },
  {
    value: 'payment',
    label: 'cmtplForm.compensation.compensationType.payment',
  },
];

export const PAYMENT_RECEIVER_TYPES = [
  { value: 'victim', label: 'cmtplForm.compensation.paymentReceiverType.victim' },
  {
    value: 'applicant',
    label: 'cmtplForm.compensation.paymentReceiverType.applicant',
  },
  { value: 'other', label: 'cmtplForm.compensation.paymentReceiverType.other' },
];

export const FILE_STATES = {
  UPLOADED: 'UPLOADED',
  PENDING: 'PENDING',
  FAILED: 'FAILED',
  INVALID: 'INVALID',
};

export const ATTACHMENT_TYPES = {
  PASSPORT: 'passport',
  DRIVER_LICENSE: 'driver_license',
  TECH_PASSPORT: 'tech_passport',
  PHOTO: 'photo',
  INVERSTIGATOR_DECISION: 'investigator_decision',
  MEDICAL_DOCS: 'medical_docs',
  RECEIPT: 'receipt',
  POWER_OF_ATTORNEY: 'power_of_attorney',
  OTHER: 'other',
  REFERENCE: 'reference',
  EPICRISIS: 'epicrisis',
  EXTRACT_FROM_OUTPATIENT_CARD: 'extract_from_outpatient_card',
  CASH_REGISTER_RECEIPT: 'cash_register_receipt',
  DM_CHECK: 'dm_check',
  AMOUNT: 'amount',
  DISABILITY_FORM: 'disability_form',
  POLICE_REPORT: 'police_report',
  DOCUMENT_CERTIFYING_RIGHT: 'document_certifying_right',
  OWNER_CERTIFICATE: 'owner_certificate',
  LOAN_AGREEMENT: 'loan_agreement',
};

export const ATTACHMENT_EXTENSIONS = {
  any: '.pdf,.doc,.docx,.odt,.jpg,.jpeg,.png',
  image: '.jpg,.jpeg,.png',
};

export const ATTACHMENT_MAX_SIZE = 1024 * 1024 * 25;
export const ATTACHMENT_VALID_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx
  'application/vnd.oasis.opendocument.text', // odt
];

export const ACCIDENT_COUNTRIES = [COUNTRIES.ARM];

export const ARMENIA_ISO3 = 'ARM';
export const RUSSIA_ISO3 = 'RUS';
export const GEORGIA_ISO3 = 'GEO';

export const VICTIM_TO_ACCIDENT = [
  { value: 'passenger', label: 'personalClaim.personalData.passenger' },
  { value: 'driver', label: 'personalClaim.personalData.driver' },
  {
    value: 'passerby_or_other',
    label: 'personalClaim.personalData.pedestrianOrOther',
  },
];

export const BLOCKED_UPLOAD_ERROR_CODE = 'BLOCKED_UPLOAD';

export const APPLICANT_TO_VICTIM = [
  { value: 'victim', label: 'personalClaim.personalData.victim' },
  { value: 'other', label: 'personalClaim.personalData.other' },
  { value: 'otherLegal', label: 'personalClaim.personalData.otherLegal' },
];

export const APPLICANT_IS_TYPES = [
  { value: 'insuredPerson', label: 'medicalClaim.personalData.insuredPerson' },
  { value: 'other', label: 'personalClaim.personalData.other' },
];

export const FILE_FORMATS = {
  CSV: 'csv',
  XML: 'xml',
};

export const USER_ROLES = {
  ADMIN: 'admin',
  USER: 'user',
  GUEST: 'guest',
  ACCOUNTANT: 'accountant',
};

export const TABLE_PARAMS = {
  DEFAULT_LIMIT: 10,
  DEFAULT_PAGE: 1,
};

export const TRANSFER_TYPES = [
  {
    value: 'transit',
    label: 'bankAccountForm.transferType.transit',
  },
  { value: 'account', label: 'bankAccountForm.transferType.account' },
];

export const TRANSFER_TYPES_WITHOUT_CASH = [
  TRANSFER_TYPES[1],
];

export const CLAIM_TYPES = {
  MEDICAL: 'medicalClaim',
  CASCO: 'cascoClaim',
  TRAVEL: 'travel-claim',
  ACCIDENT: 'accident-claim',
  PROPERTY: 'property',
};

export const CONTRACT_TYPES = {
  TRAVEL: 'travelContract',
  PROPERTY: 'propertyContract',
  CMTPL: 'cmtplContract',
  ONCO_CARE: 'oncoCareContract',
  ROAD_CARE: 'roadCareContract',
};

export const APPLICATION_CONTRACT_TYPES = {
  TRAVEL: 'travel',
  PROPERTY: 'property',
  ONCO_CARE: 'oncocare',
  ROAD_CARE: 'roadcare',
  CMTPL: 'appa',
  CMTPL_CASCO: 'appacasco',
  VMTPL: 'appka',
};

export const RISK_AMOUNT_TYPES = {
  AUTO_CARE: 'autocare_online',
};

export const MEMBER_TYPES = {
  TRAVELER: 'traveler',
  OWNER: 'owner',
  INSURED_PERSON: 'person',
};

export const INSURANCE_TYPES = {
  CMTPL: 'cmtpl',
  CMTPL_CASCO: 'cmtpl-casco',
  VMTPL: 'vmtpl',
  PROPERTY: 'property',
  TRAVEL: 'travel',
};

export const CALCULATOR_TYPES = {
  CMTPL: 'cmtpl',
  CMTPL_CASCO: 'cmtplCasco',
  VMTPL: 'vmtpl',
  TRAVEL: 'travel',
  CASCO: 'casco',
  PROPERTY: 'property',
};

export const REGISTERED_IN_RA = [
  { label: 'cmtplContract.vehicleInfo.registeredInRA', value: 1 },
  { label: 'cmtplContract.vehicleInfo.notRegisteredInRA', value: 0 },
];

export const REGISTERED_IN_RP = [
  { label: 'cmtplContract.vehicleInfo.registeredInRP', value: 1 },
  { label: 'cmtplContract.vehicleInfo.notRegisteredInRP', value: 0 },
];

export const PLATE_NUMBER_STATUS = {
  IS_YELLOW: 1,
  IS_NOT_YELLOW: 0,
};

export const VEHICLE_USE_TYPES_BY_POLICY_HOLDER_TYPE = {
  INDVD: ['OWN', 'TAX', 'COM'],
  LEGAL: ['SRV', 'TAX', 'COM', 'PBL'],
};

export const NATIONALITY_NAMES = {
  ARM: 'ՀԱՅ',
};

export const SEX = {
  MALE: 'Ա',
  FEMALE: 'Ի',
};

export const MIN_DOCUMENT_NUMBER = 3;

export const DOCUMENT_TYPE = {
  PASSPORT: 'passport',
};

export const AUTOMATIC_RECURRING_PAYMENT_TYPES = {
  MONTHLY: 'permonth',
  QUARTERLY: 'quarterly',
  SEMIANNUAL: 'semiannual',
};

export const PAYMENT_FREQUENCY_TYPES = {
  MONTHLY: 'permonth',
  QUARTERLY: 'quarterly',
  SEMIANNUAL: 'semiannual',
  ONETIME: 'onetime',
};

export const PAYMENT_FREQUENCY_OPTIONS = {
  [PAYMENT_FREQUENCY_TYPES.MONTHLY]: 'permonthPayments',
  [PAYMENT_FREQUENCY_TYPES.QUARTERLY]: 'quarterlyPayments',
  [PAYMENT_FREQUENCY_TYPES.SEMIANNUAL]: 'semiannualPayments',
};

export const CONTRACT_STEPS = {
  PAYMENT_STEP: 'payment',
};

// Here are set currencies that we are getting from price request
export const CALCULATOR_LIMIT_CURRENCIES = {
  USD: 'USD',
  EUR: 'EUR',
};

export const ACTION_TYPES = {
  CREATE: 'create',
  EDIT: 'edit',
  DELETE: 'delete',
};

export const AMD_SYMBOL = '֏';
export const USD_SYMBOL = '$';
export const EUR_SYMBOL = '€';
export const CURRENCY_SYMBOLS = {
  AMD: AMD_SYMBOL,
  USD: USD_SYMBOL,
  EUR: EUR_SYMBOL,
};

// NOTE: renamed card to ameria as it has been already stored in backend
export const PAYMENT_METHOD = {
  FREE: 'free',
  CARD: 'ameria',
  IDRAM: 'idram',
};

export const ATTACH_PAYMENT_CARD_OPTIONS = {
  ATTACH_CARD: 'attach-card',
  ATTACH_EXISTING_RECURRING_CONTRACT_CARD: 'attach-existing-recurring-contract-card',
};

export const ATTACH_PAYMENT_CARD_AMOUNT = 10;

export const ACTION_NAME = {
  CONTRACT: 'contract',
  CALCULATOR: 'calculator',
};

export const EFES_PHONE_NUMBER = '(010)-700-800';

export const ACC_INITIAL_ADDRESS = {
  isAccInArmenia: true,
  accCountry: null,
  accState: null,
  accVillage: null,
};

export const CAR_INITIAL_ADDRESS = {
  isCarInArmenia: false,
  carCountry: null,
  carState: null,
  carVillage: null,
};

export const APPLICATION_STATUSES = [
  { text: 'RECEIVED', datePropName: 'invoiceInputDate' },
  { text: 'IN_REVIEW', datePropName: 'acceptDate' },
  { text: 'PROCESSED', datePropName: 'invoiceSettleDate' },
  { text: 'PAYMENT', datePropName: 'invoicePayDate' },
];

export const REFERRAL_STATUSES = [{ text: 'REFERRED', datePropName: 'invoiceInputDate' }];

export const CASCO_STATUSES = [
  { text: 'REGISTRATION', datePropName: 'invoiceInputDate' },
  { text: 'ACCEPTANCE', datePropName: 'declarationDate' },
  { text: 'ASSESSMENT', datePropName: 'assessmentDate' },
  { text: 'EXAMINATION', datePropName: 'examinationDate' },
  { text: 'SETTLEMENT', datePropName: 'settlementDate' },
  { text: 'PAYMENT', datePropName: 'invoicePayDate' },
];

export const CASCO_REFERRAL_STATUSES = [{ text: 'SENT_TO_REPAIR', datePropName: 'acceptDate' }];

export const SUPPORT_PHONE = '(+374 10) 700 800';
export const SUPPORT_EMAIL = 'mailto:info@efes.am';

export const PALETTE_COLOR_TYPES = {
  PRIMARY: 'primary',
};

export const CLAIM_STATUS_TYPES = [
  {
    id: 1,
    label: 'medicalClaim',
  },
  {
    id: 2,
    label: 'travelClaim',
  },
  {
    id: 3,
    label: 'accidentClaim',
  },
  {
    id: 4,
    label: 'cascoClaim',
  },
];
